import * as yup from 'yup';
import YupPassword from 'yup-password';
import { YOptionalE164PhoneValidateAllowing, YRequiredPhoneValidate } from '../yupValidators';
export const signUpInitialValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  password: '',
  repPassword: '',
  termsAndConditions: false,
  privacyPolicy: false,
  userAcknowledgment: false
};
YupPassword(yup);
export const PASSWORD_MIN_ERROR = 'PASSWORD_MIN_ERROR';
export const PASSWORD_RULES_ERROR = 'PASSWORD_RULES_ERROR';
export const PASSWORD_REQUIRED_ERROR = 'PASSWORD_REQUIRED_ERROR';
export const signUpSchema = yup.object({
  firstName: yup.string().trim().min(2, 'errors.min').max(50, 'errors.max').required('errors.required'),
  lastName: yup.string().trim().min(2, 'errors.min').max(50, 'errors.max').required('errors.required'),
  email: yup.string().trim().email('errors.invalid').required('errors.required'),
  phone: YRequiredPhoneValidate,
  password: yup.string().trim().minUppercase(1, PASSWORD_RULES_ERROR).minLowercase(1, PASSWORD_RULES_ERROR).minNumbers(1, PASSWORD_RULES_ERROR).minSymbols(1, PASSWORD_RULES_ERROR).min(8, PASSWORD_MIN_ERROR).required(PASSWORD_REQUIRED_ERROR),
  repPassword: yup.string().trim().oneOf([yup.ref('password'), null]).required(),
  termsAndConditions: yup.boolean().oneOf([true], '').required(),
  privacyPolicy: yup.boolean().oneOf([true], '').required(),
  userAcknowledgment: yup.boolean().oneOf([true], '').required()
});
export const createPersonalInformationSchema = initialPhone => yup.object({
  email: yup.string().trim().email('errors.invalid').required('errors.required'),
  firstName: yup.string().trim().min(2, 'errors.min').max(50, 'errors.max').required('errors.required'),
  lastName: yup.string().trim().min(2, 'errors.min').max(50, 'errors.max').required('errors.required'),
  phone: YOptionalE164PhoneValidateAllowing(initialPhone)
});